import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgSuccessCircle32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M27 16c0 6.075-4.925 11-11 11S5 22.075 5 16 9.925 5 16 5s11 4.925 11 11m-5.793-2.293a1 1 0 0 0-1.414-1.414L14.5 17.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3.707 3.707z" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgSuccessCircle32);
export default Memo;